import Vue, { VueConstructor, DirectiveOptions, VNode, VNodeData, VNodeDirective } from 'vue'
import { warn } from './utils'
import { BuryParams } from './types/bury-tool'
import { MultBuryItem } from './types/bury-point'

interface watchItem extends VNodeDirective {
  rawName: string;
}

const findExpression = (directives: watchItem[]) => {
  const rawName = ['v-report-watch', 'v-model', 'v-show']
  const map: {
    [key: string]: watchItem
  } = {}
  directives.forEach((dir) => {
    map[dir.rawName] = dir
  })

  while (rawName.length) {
    const name = rawName.shift()
    if (name && map[name]) {
      return map[name]
    }
  }

  return null
}

export default function(__Vue: VueConstructor<Vue>) {
  const buryPointDirective: DirectiveOptions = {
    inserted(el, opt, vnode: VNode) {
      const { value: arg, modifiers } = opt

      el.__buryPointValueStore__ = arg

      const { context } = vnode

      const report = function report() {
        if (context && context.$buryPoint) {
          const store = el.__buryPointValueStore__ || arg
          const [p1, p2, p3]: [string, BuryParams?] & [
            string,
            (string | MultBuryItem[])?,
            BuryParams?
          ] = store
          context.$buryPoint.report(p1, p2, p3)
        }
      }

      const { once: isOnce, watch: isWatch } = modifiers
      if (!isOnce && !isWatch) {
        el.addEventListener('click', () => {
          report()
        })
        return
      }

      if (isOnce && isWatch) {
        warn('v-report不允许同时使用 once watch 修饰 (in applyDirective)', el)
        return
      }

      if (isOnce) {
        report()
        return
      }

      // etype === view
      const { data } = vnode
      const { directives, model } = <VNodeData>data
      const _directives = JSON.parse(JSON.stringify(directives))
      if (model) {
        _directives.push({
          rawName: 'v-model',
          ...model
        })
      }
      const watchDir = findExpression(_directives)

      // 非v-show 绑定的dom，即为页面view
      if (!watchDir) {
        warn('v-report.watch 无法找到["v-report-watch", "v-model", "v-show"]中的任一观察对象 (in applyDirective)', el)
        report()
        return
      }

      // v-show绑定的弹窗之类的
      const { expression, value } = watchDir
      context && context.$watch(
        expression,
        (nval) => {
          if (nval) {
            report()
          }
        },
        {
          immediate: value
        }
      )
    },
    componentUpdated(el, opt) {
      const { value: arg } = opt
      el.__buryPointValueStore__ = arg
    },
  }

  __Vue.directive('report', buryPointDirective)
  __Vue.directive('report-watch', {})
}
